import { ARGB_To_RGBA_Color } from "../constants";
import PropTypes from "prop-types";

function Rectangle(props) {
  const { rectangle, fType } = props;
  return (
    <div
      data-testid="rectangle"
      style={{
        width: rectangle.Width,
        height: rectangle.Height,
        position: "absolute",
        top: rectangle.SetTop,
        left: rectangle.SetLeft + 10,
        border: rectangle.StrokeThickness,
        borderStyle: "solid",
        borderColor:
          fType === "NonAcord"
            ? ARGB_To_RGBA_Color(rectangle.Stroke.Color)
            : rectangle.Stroke.Color,
      }}
    ></div>
  );
}

Rectangle.propTypes = {
  rectangle: PropTypes.shape({
    Width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    StrokeThickness: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Stroke: PropTypes.shape({
      Color: PropTypes.string,
    }),
  }).isRequired,
  fType: PropTypes.string,
};

Rectangle.defaultProps = {
  fType: "",
};

export default Rectangle;
